Vue.component("home", {
    props: ["user"],

    /**
     * Load mixins for the component.
     */
    //mixins: [require("../tab-state")],

    /**
     * Prepare the component.
     */
    mounted() {
        //this.usePushStateForTabs(".spark-settings-tabs");
    },
    computed: {
        currentRoute: {
            get() {
                this.nombreRuta = this.$route.name;
            }
        }
    },

    /**
     * The component has been created by Vue.
     */
    created() {
        /*Bus.$on("sparkHashChanged", function(hash, parameters) {
            if (hash === "users") {
                setTimeout(() => {
                    $("#kiosk-users-search").focus();
                }, 150);
            }

            return true;
        });
        */
    },
    methods: {}
});
